import styled from 'styled-components'

export default styled.div`
  /* padding-bottom: 98px; */
  margin-top: 9.6vw;

  .logo {
    margin-top: 0;
    margin-bottom: 59px;
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 210px;
    height: 33px;
  }

  .search-bar {
    margin: 0 3vw;

    .react-search-bar__wrapper {
      width: 240px;
    }
  }

  .hint {
    margin: 21px 20px 27px 20px;
    height: 32px;
    /* font-family: 'ABChanel PB Regular S', Arial, sans-serif; */
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 10px;
    line-height: 1.6;
    letter-spacing: -0.035em;
    text-align: center;
    color: #000000;
    html[lang=tw] & {
      font-size: 12px;
    }
  }

  .tutorial {
    display: block;
    font-family: 'ABChanel PB SemiBold L', Arial, sans-serif;
    font-size: 12px;
    font-weight: normal;
    line-height: 1.33;
    letter-spacing: -0.3px;
    text-align: center;
    text-decoration: underline;
    color: #000000;
    margin-bottom: 78px;
  }

  .browse-all-products-btn {
    margin-top: 52px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/Explore.js